import serverAPI from '@/services/serverAPI'

/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 */
const fetchProfileSettings = async ({ commit }) => {
  const response = await serverAPI.fetchProfileSettings()

  commit('setProfileTimezone', response.timezone)
}

/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 * @param {object}       payload
 */
const updateProfileSettings = async ({ commit }, payload) => {
  const response = await serverAPI.updateProfileSettings(payload)

  commit('setProfileTimezone', response.timezone)
}

export default {
  fetchProfileSettings,
  updateProfileSettings
}
